import { MutationTree } from "vuex";
import { GeneralState } from "./types";

export const mutations: MutationTree<GeneralState> = {
  SET_ACTIVE_COACHMARK(state, activeCoachmark: number) {
    state.activeCoachmark = activeCoachmark;
  },
  RESET_ACTIVE_COACHMARK(state) {
    state.activeCoachmark = 0;
  },
};
